import { render, staticRenderFns } from "./InfosPCCourseFiche.vue?vue&type=template&id=5ac20255&scoped=true&"
import script from "./InfosPCCourseFiche.vue?vue&type=script&lang=js&"
export * from "./InfosPCCourseFiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac20255",
  null
  
)

export default component.exports